<template>
  <div class="row">
    <div :class="`${formularioSelecionado.col || 'col-xs-12'}`">
      <div class="row">
        <h4 v-if="mostrarTitulo" class="mb-5 mt-5">{{ formularioSelecionado.dados.titulo }}</h4>
        <template v-for="(listaDeCampos) in camposFormulario">
          <TexInputComponent
            v-if="
              listaDeCampos.type == 'text' ||
              listaDeCampos.type == 'textarea' ||
              listaDeCampos.type == 'autocomplete' ||
               listaDeCampos.type == 'date-time' ||
              listaDeCampos.type == 'number' &&
              verificadorCondicional(listaDeCampos.show)
            "
            :name="listaDeCampos.name"
            :type="getTipoInput(values[listaDeCampos.name], listaDeCampos.type)"
            :label="listaDeCampos.label"
            :placeholder="listaDeCampos.placeholder"
            :class="listaDeCampos.col"
            v-model="values[listaDeCampos.name]"
            :key="values[listaDeCampos.name]"
            :readonly="true"
            rows="7"
          />

          <ComboboxInputComponent
            v-else-if="
              listaDeCampos.type == 'select' ||
              listaDeCampos.type == 'radio' ||
              listaDeCampos.type == 'select-avancado' &&
              verificadorCondicional(listaDeCampos.show)
            "
            :name="listaDeCampos.name"
            :type="listaDeCampos.type"
            :label="listaDeCampos.label"
            :options="values[listaDeCampos.name] ? { [values[listaDeCampos.name]]: recuperarLabel(values[listaDeCampos.name], listaDeCampos.options, listaDeCampos) } : listaDeCampos.options"
            :class="`${listaDeCampos.col} select-readonly`"
            v-model="values[listaDeCampos.name]"
            :key="`${values[listaDeCampos.name]}`"
            :readonly="true"
          ></ComboboxInputComponent>

          <ComboboxInputComponent
            v-else-if="
              listaDeCampos.type == 'requisicao' &&
              verificadorCondicional(listaDeCampos.show)
            "
            :name="listaDeCampos.name"
            :type="listaDeCampos.type"
            :label="listaDeCampos.label"
            :options="validaValorRequisicao(values[listaDeCampos.name], listaDeCampos.options)"
            :class="`${listaDeCampos.col} select-readonly`"
            v-model="values[listaDeCampos.name]"
            :key="`${values[listaDeCampos.name]}`"
            :readonly="true"
          ></ComboboxInputComponent>

          <DateInputComponent
              v-else-if="
                listaDeCampos.type == 'date' ||
                listaDeCampos.type == 'date-time' ||
                listaDeCampos.type == 'time' ||
                listaDeCampos.type == 'datetime-local' &&
                verificadorCondicional(listaDeCampos.show)
              "
              :name="listaDeCampos.name"
              :type="listaDeCampos.type"
              :label="listaDeCampos.label"
              :validation="listaDeCampos.validation"
              :placeholder="listaDeCampos.placeholder"
              :class="listaDeCampos.col"
              :key="listaDeCampos.id"
              v-model="values[listaDeCampos.name]"
              :readonly="true"
            />

            <HiperlinkComponent 
            v-else-if="
              (listaDeCampos.type == 'url' || listaDeCampos.type == 'link') &&
              verificadorCondicional(listaDeCampos.show)
            "
            :key="values[listaDeCampos.id]"
            :label="listaDeCampos.label"
            v-model="values[listaDeCampos.name]"
          />

        </template>

      </div>

    </div>

  </div>

</template>

<script>
import Vue from 'vue';
import '@/assets/css/formulate.css';
import VueFormulate from '@braid/vue-formulate';
import { pt } from '@braid/vue-formulate-i18n';
import TexInputComponent from './TexInputComponent.vue';
import ComboboxInputComponent from './ComboboxInputComponent.vue';
import DateInputComponent from './DateInputComponent.vue';
import HiperlinkComponent from './HiperlinkComponent.vue';


Vue.use(VueFormulate, {
  classes: {
    inputHasErrors: 'is-invalid',
    errors: 'list-unstyled text-danger',
  },
  locale: 'pt',
  plugins: [pt],
});

export default {
  name: 'ReadonlyFormularioComponent',

  components: {
    TexInputComponent,
    ComboboxInputComponent,
    DateInputComponent,
    HiperlinkComponent
  },

  props: {
    formularioSelecionado: {
      type: Object,
      required: true,
    },
    formValues: {
      type: Object,
      required: true,
    },    
    acaoFormulario: {
      type: String,
      required: false,
      default: 'cadastrar'
    },
    endpoint: {
      type: String,
      required: false,
      default: () => ''
    },
    exportarDados: {
      type: Boolean,
      required: false,
      default: false
    },
    mostrarTitulo: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data () {
    //condicional para tratar dados de formulario legado
    if (typeof this.formularioSelecionado.dados == 'undefined') {
      if (Array.isArray(this.formularioSelecionado)) {
          this.formularioSelecionado = this.formularioSelecionado[0];
      } else{
        this.formularioSelecionado.dados = this.formularioSelecionado;
      }
    }
    return {
      values: { ...this.formValues },
      gatilhos: []
    }
  },

  computed: {
    camposFormulario () {
      if (this.formularioSelecionado.dados && this.formularioSelecionado.dados.corpo) {
        return this.formularioSelecionado.dados.corpo.filter(campo => campo.name in this.formValues)
      } else if (Array.isArray(this.formularioSelecionado.corpo)) {
        return this.formularioSelecionado.corpo.filter(campo => campo.name in this.formValues)
      } else if (Array.isArray(this.formularioSelecionado)) {
        return this.formularioSelecionado[0].dados.corpo.filter(campo => campo.name in this.formValues)
      }
      return []
    }
  },

  methods: {
    verificadorCondicional (val) {
      return eval(val)
    },

    getTipoInput (val, type) {
      let tipoDado = 'text';
      if (type === 'text' || type === 'autocomplete') {
        if(val.includes('\n') || val.includes('\r\n')) {
          tipoDado = 'textarea';
        }
      } else{
        tipoDado = (type ==='radio') ? 'text' : type;
      }

      const camposTexto = [
        'url',
        'number'
      ]

      if (camposTexto.includes(type)) {
        tipoDado = 'text'
      }

      if (type == 'select-avancado') {
        tipoDado = 'select'
      }

      if (type === 'date-time') {
        tipoDado = 'datetime-local'
      }
      return tipoDado;
    },
    
    recuperarLabel (val, options, campo) {      
      if (campo.type == 'select-avancado') {
        const valorOptions = this.values[campo.nome_enderecamento]
        const options = campo.options[valorOptions]
        return options[val]
      }

      return options[val]

      // for(const option in options) {
      //   if (val === option) {
      //     return options[option]
      //   }
      // }
    },

    validaValorRequisicao (val, options) {      
      const item = options.find(opt => opt.value == val)
      const retorno = {[item.value]: item.label}
      return retorno     
    }
  },
};
</script>